import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { Container, Card, Button, TextField, Typography, FormControl, CardContent, Autocomplete, Box, Paper, Link } from '@mui/material';
import { useTheme, useMediaQuery, BottomNavigation, BottomNavigationAction} from '@mui/material';

import GroupIcon from '@mui/icons-material/Group';
import EditIcon from '@mui/icons-material/Edit';
import AssessmentIcon from '@mui/icons-material/Assessment';
import BusinessIcon from '@mui/icons-material/Business';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

import OrgForm from '../utils/OrgForm';
import CompanyLogo from '../CompanyLogo';
import { useAuth } from '../AuthContext';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import SelfAssessment from './SelfAssessment';
import ClientDetails from './ClientDetails';
import Signup from './signup';
import Reachouts from './Reachouts';
import SetupGmail from '../utils/setupgmail';

import LinkedInReachOuts from './linkedin';

const Execedge = () => {
    const { user } = useAuth();
    const [targetCompanies, setTargetCompanies] = useState([]);
    const [organizations, setOrganizations] = useState([]);
    const [newCompany, setNewCompany] = useState({ name: '', organization: '', status: '' });
    const [loading, setLoading] = useState(true);
    const [email, setEmail] = useState('');
    const [OrgEdit, setOrgEdit] = useState('');
    const [Project, setProject] = useState([]);
    const [decisionMakers, setDecisionMakers] = useState([]);
    const [AllProject, setAllProject] = useState([]);
    const [AddNew, setAddNew] = useState(0);
    const [newClient, setNewClient] = useState({ email: '', client: '' });
    const [openSetupGmail, setOpenSetupGmail] =  useState(0);
    const [ComponyFilter, setComponyFilter] = useState([]);
    const [showComments, setShowComments] = useState('');
    const [newComment, setNewComment] = useState({});
    
  const [inputValue, setInputValue] = useState('');
  const [options, setOptions] = useState([]);
  const [Cloading, setCLoading] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  const userStatus = {
    'Pending': ['Pending'],
    'Approved': ['Approved'],
    'To be Reviewed': ['To be Reviewed'],
    'Approved for Research': ['Approved for Research'],
    'Research in Progress':['DMs Identified','Discarded After Research','DMs Verified','Modifications Required','Pending Approval','Share with Client'],                        
    'Reserch Compleated':['Share with Client'],
    'Reject': ['Reject']
};
const adminStatus = {
    'Pending': ['Pending'],
    'Approved': ['Approved'],
    'To be Reviewed': ['To be Reviewed'],
    'Approved for Research': ['Approved for Research'],
    'DMs Identified':['DMs Identified'],
    'Research in Progress':['Research in Progress'],
    'DMs Identified':['DMs Identified'],
    'DMs Verified':['DMs Verified'],
    'Modifications Required': ['Modifications Required'],
    'Pending Approval':['Pending Approval'],
    'Share with Client':['Share with Client'],
    'Discarded After Research': ['Discarded After Research'],    
    'Reject': ['Reject'],
}
 const Recruiteroption =
 {
    'Pending': ['Pending'],
    'Approved': ['Approved'],
    'To be Reviewed': ['To be Reviewed'],
    'Approved for Research': ['Approved for Research'],
    'DMs Identified':['DMs Identified'],
    'Research in Progress':['Research in Progress'],
    'DMs Identified':['DMs Identified'],
    'DMs Verified':['DMs Verified'],
    'Modifications Required': ['Modifications Required'],
    'Pending Approval':['Pending Approval'],
    'Share with Client':['Share with Client'],
    'Discarded After Research': ['Discarded After Research'],    
    'Reject': ['Reject'],
 }

 
const tabOptions = [
    ...(user.role === "admin" || user.role === "recruiter" ? [{ label: 'Self Assessment', icon: <AssessmentIcon /> }]:[]),
    { label: 'Target Companies', icon: <BusinessIcon /> },
    { label: 'Email Outreach', icon: <MailOutlineIcon /> },
    { label: 'Linkedin Outreach', icon: <LinkedInIcon /> },
    ...(user.role === "admin" || user.role === "recruiter" ? [{ label: 'Client Details', icon: <BusinessIcon /> }] : [])
  ];
  // Fetch organizations from the server based on input
  useEffect(() => {
    const fetchOrganizations = async () => {
      if (inputValue.trim() === '') {
        setOptions([]);
        return;
      }

      setCLoading(true);
      try {
        const response = await axios.get('/api/organizations', {
          params: { query: inputValue },
        });
        const uniqueOptions = Array.from(new Set(response.data.map(org => org.name)))
                       .map(name => response.data.find(org => org.name === name));
        setOptions(uniqueOptions);
      } catch (error) {
        console.error('Error fetching organizations:', error);
      } finally {
        setCLoading(false);
      }
    };

    // Debounce the API call to avoid excessive requests
    const debounceTimer = setTimeout(() => {
      fetchOrganizations();
    }, 200);

    return () => clearTimeout(debounceTimer);
  }, [inputValue]);

    const fetchAuthorizedEmails = async () => {
        try {
          const response = await axios.get(`/api/emails/authorized?email=${user.email}`);
          return(response.data);
        } catch (error) {
          console.error('Error fetching authorized emails:', error);
        }
      };

    useEffect(() => {
            setEmail(user.email);    
            if(user.role === "admin" || user.role === "recruiter"){
                getAllProjects();
                tabOptions.push({ label: 'Client Details', icon: <BusinessIcon /> }); 

            }  
    }, [user]);      

    useEffect(() => {
        const checkAuthorizedEmails = async () => {
            const authorizedEmails = await fetchAuthorizedEmails();
            if (
                (!authorizedEmails || authorizedEmails.length === 0) 

               // && activeTab === 'Reachouts'
        ) {
                console.log("Show setup Gmail");
                setOpenSetupGmail(true);
            }
        };

        checkAuthorizedEmails();
    }, []);

    const handleAddClient = async () => {
        try {
            await axios.post('/api/execedge/newClient', newClient);
            setNewClient({ email: '', client: '' });
            getAllProjects();
        } catch (error) {
            console.error('Error adding new client:', error);
        }
    };

    const getAllProjects = async () => {
        try {
            const response = await axios.get('/api/execedge/getAll');
            setAllProject(response.data || []);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching target companies:', error);
        }
    };

    
    const fetchTargetCompanies = useCallback(async () => {
        try {
            if (!email) return;
            const response = await axios.get(`/api/execedge/get?email=${email}`);
            setProject(response.data || []);
            const uniqueCompanies = response.data && response.data.TargetCompany
                ? Array.from(new Set(response.data.TargetCompany.map(company => company.Name)))
                    .map(name => response.data.TargetCompany.find(company => company.Name === name))
                : [];
            setTargetCompanies((uniqueCompanies || []).reverse());
            setLoading(false);
        } catch (error) {   
            console.error('Error fetching target companies:', error);
        }
    }, [email]);

    const EditReMark = async (company) => {
        try {

            // Open dialog with current remark
            const result = await Dialog.confirm({
                title: 'Edit Remark',
                content: (
                    <TextField
                        defaultValue={company.Remarks || ''}
                        fullWidth
                        multiline
                        rows={4}
                        id="company-remark"
                    />
                ),
                onOk: async () => {
                    const newRemark = document.getElementById('company-remark').value;
                   
                await axios.post('/api/execedge/updateTargetCompanyStatusByEmail', {
                    email,
                    Name: company.Name,
                    Status: company.Status,
                    Priority: company.Priority,
                    Remarks: newRemark,
                    User: user.email
                });
                fetchTargetCompanies();
                }
            });

        } catch (error) {
            console.error('Error updating company remark:', error);
        }
        
            }

    useEffect(() => {
        fetchTargetCompanies();
    }, [fetchTargetCompanies]);

    const fetchDecisionMakers = useCallback(async () => {
        try {
          if (!Project?._id) return;
          const id = Project._id;
      
          // Fetch all decision makers
          const response = await axios.get(`/api/execedge/Aassociations/${id}`);
          const decisionMakers = response.data || [];
      
          if (decisionMakers.length === 0) {
            setDecisionMakers([]);
            setLoading(false);
            return;
          }
      
          // Extract WorkEmails
          const emails = decisionMakers.map(dm => dm.WorkEmail).filter(Boolean);
      
          // Validate emails
          const validationResponse = await axios.post('/api/validate-emails', { emails });
          const validatedData = validationResponse.data?.data || [];
      
          // Map email -> validation result
          const validationMap = {};
          validatedData.forEach(({ email, ...rest }) => {
            validationMap[email] = rest;
          });
      
          // Merge validation result into each decision maker
          const updatedDecisionMakers = decisionMakers.map(dm => ({
            ...dm,
            validationStatus: validationMap[dm.WorkEmail]?.status || 'Unknown',
          }));
      
          setDecisionMakers(updatedDecisionMakers);
      
          // Now handle "To Be Checked" emails
          const toBeCheckedEmails = updatedDecisionMakers
            .filter(dm => dm.validationStatus === "To Be Checked")
            .map(dm => dm.WorkEmail);
      
          if (toBeCheckedEmails.length > 0) {
            await handleSendTestEmails(toBeCheckedEmails); // Call test email function
          }
      
          setLoading(false);
        } catch (error) {
          console.error('Error fetching or validating decision makers:', error);
          setLoading(false);
        }
      }, [Project]);
      
      const handleSendTestEmails = async (emails) => {
        try {
          await axios.post("/api/send-test-email", { emails });
          console.log(`Test emails sent to ${emails.length} addresses`);
        } catch (error) {
          console.error('Failed to send test emails', error);
        }
      };
      

    useEffect(() => {
        fetchDecisionMakers();
    }, [fetchDecisionMakers]);

    useEffect(() => {
        const fetchOrganizations = async () => {
            try {
                const response = await axios.get('/api/organizations');                
                setOrganizations(response.data);
            } catch (error) {
                console.error('Error fetching organizations:', error);
            }
        };

        fetchOrganizations();
    }, []);

    const handleStatusChange = async (companyName, newStatus, Priority="") => {
        try {
            await axios.post('/api/execedge/updateTargetCompanyStatusByEmail', {
                email,
                Name: companyName,
                Status: newStatus,
                Priority: Priority,
                User: user.email
            });
            setTargetCompanies(prevCompanies =>
                prevCompanies.map(company =>
                    company.Name === companyName ? { ...company, Status: newStatus, Priority: Priority } : company
                )
            );
            fetchDecisionMakers();
        } catch (error) {
            console.error('Error updating company status:', error);
        }
    };

   
        const [openModal, setOpenModal] = useState(false);
        const [selectedCompany, setSelectedCompany] = useState(null);
        const [newStatus, setNewStatus] = useState('');
        const [reason, setReason] = useState('');
        const [CandidateId, setCandidateId] = useState('');

        const handleOpenModal = (company, status, candidateId="") => {
            setSelectedCompany(company);
            setCandidateId(candidateId);
            setNewStatus(status);
            setOpenModal(true);
        };

        const handleCloseModal = () => {
            setOpenModal(false);
            setSelectedCompany(null);
            setCandidateId('');
            setNewStatus('');
            setReason('');
        };

        const StatusChangeWithComment = async (company, status, Priority="", candidateId="") => {
            handleOpenModal(company, status, candidateId);
        }
        const handleSubmit = async () => {
            try {
                if(CandidateId !== ""){
                    await axios.post('/api/execedge/updateConnectionStatusByEmail', {
                        ExecEdgeId: Project._id,
                        candidateId: CandidateId,
                        Status: newStatus
                    });
                    setDecisionMakers(prevDecisionMakers =>
                        prevDecisionMakers.map(decisionMaker =>
                            decisionMaker.candidateId._id === CandidateId ? { ...decisionMaker, status: newStatus } : decisionMaker
                        )
                    );
                    await handleAddCommentdecisionMaker(CandidateId);
                    
                }
            else
                    {
                await axios.post('/api/execedge/updateTargetCompanyStatusByEmail', {
                    email,
                    Name: selectedCompany.Name,
                    Status: newStatus,
                });
                setTargetCompanies(prevCompanies =>
                    prevCompanies.map(company =>
                        company.Name === selectedCompany.Name ? { ...company, Status: newStatus } : company
                    )
                );
                await handleAddComment(selectedCompany._id);
            }
                handleCloseModal();
            } catch (error) {
                console.error('Error updating company status:', error);
            }
        };


    const handleConnectionStatusChange = async (candidateId, newStatus) => {
        try {
            await axios.post('/api/execedge/updateConnectionStatusByEmail', {
                ExecEdgeId: Project._id,
                candidateId,
                Status: newStatus
            });
            setDecisionMakers(prevDecisionMakers =>
                prevDecisionMakers.map(decisionMaker =>
                    decisionMaker.candidateId._id === candidateId ? { ...decisionMaker, status: newStatus } : decisionMaker
                )
            );
        } catch (error) {
            console.error('Error updating connection status:', error);
        }
    };

    const handleAddCommentdecisionMaker = async (decisionMakerId) => {
        try {
            await axios.post('/api/execedge/addAssoComment', {
                ExecEdgeId: Project._id,
                decisionMakerId,
                comment: newComment
            });
            setNewComment({});
            fetchDecisionMakers();
        } catch (error) {
            console.error('Error adding comment:', error);
        }
    }

    const handleAddCompany = async () => {
        try {
            if (!newCompany.organization) return;
            if (newCompany.organization.trim() === '') return;
            if(targetCompanies.find(company => company.Name === newCompany.organization)) 
                {
                    alert("Company already exists");
                    return;}
            await axios.post('/api/execedge/addTargetCompanyByEmail', {
                email,              
                Organization: newCompany.organization,
                Status: 'To be Reviewed',
                addedBy: user.email
            });
            setNewCompany({ email: '', organization: '', status: '' });
            fetchTargetCompanies();
        } catch (error) {
            console.error('Error adding new company:', error);
        }
    };
    const [activeTab, setActiveTab] = useState('Target Companies');
    const [CompanyStatus, setCompanyStatus] = useState('To be Reviewed');

    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };


    const handleAddComment = async (companyId) => {
        try {
            await axios.post('/api/execedge/addComment', {
                email,
                companyId,
                comment: newComment
            });
            setNewComment({});
            fetchTargetCompanies();
        } catch (error) {
            console.error('Error adding comment:', error);
        }
    }


    return (
        <>
           
           <Container maxWidth="lg" sx={{ py: 4 }}>
    { (user.role === "admin" || user.role === "recruiter") && (
                    <Card elevation={3}>
                        <CardContent>
                            <FormControl fullWidth sx={{ mt: 2 }}>
                                <Autocomplete
                                    options={AllProject.map(project => project.email)}
                                    getOptionLabel={(option) => option}
                                    renderInput={(params) => <TextField {...params} label="User Email" />}
                                    onChange={(e, newValue) => setEmail(newValue)}
                                />                                
                            <Button onClick={() => setAddNew(true)}> New Client</Button>
                            </FormControl>
                        </CardContent>
                        <CardContent  style={{ display: AddNew ? 'block' : 'none' }}>
                            <Typography variant="h6" gutterBottom>
                                Add New Client
                            </Typography>
                            <FormControl fullWidth sx={{ mt: 2 }}>
                                <TextField
                                    label="Email"
                                    value={newClient.email || ''}
                                    onChange={(e) => setNewClient({ ...newClient, email: e.target.value })}
                                    fullWidth
                                    sx={{ mb: 2 }}
                                />
                                <TextField
                                    label="Client"
                                    value={newClient.Client || ''}
                                    onChange={(e) => setNewClient({ ...newClient, Client: e.target.value })}
                                    fullWidth
                                    sx={{ mb: 2 }}
                                />
                            </FormControl>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleAddClient}
                                sx={{ mt: 2 }}
                            >
                                Add Client
                            </Button>
                        </CardContent>
                    </Card>

                )  //*/  
                }
    { // (Project.email) && ( <Reachouts decisionMakers={decisionMakers} Project={Project} fetchDecisionMakers={fetchDecisionMakers}/> )
    } 
        
        {(Project.email) &&   (
            <>                
                <div style={{ 
    display: 'flex', 
    gap: '2rem', 
    flexWrap: 'wrap', 
    justifyContent: 'flex-start', 
    marginTop: '20px', 
    fontFamily: 'Arial, sans-serif', 
    fontSize: '1.3rem', 
    textAlign: 'center' 
}}>
{
isMobile ? (
  <BottomNavigation
    showLabels
    value={activeTab}
    onChange={(event, newValue) => handleTabChange(newValue)}
    sx={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      borderTop: '1px solid #ddd',
      zIndex: 1300,
      //backgroundColor: '#fff',
    }}
  >
    {tabOptions.map(({ label, icon }) => (
      <BottomNavigationAction
        key={label}
        label={label}
        value={label}
        icon={icon}
        sx={{ color: activeTab === label ? '#FF5733' : 'inherit' }}
      />
    ))}   
  </BottomNavigation>
) : (
    <Box
    sx={{
      display: 'flex',
      gap: 4,
      px: 3,
      py: 1,
      borderBottom: '1px solid #eee',
      //backgroundColor: '#fff',
    }}
  >
    {tabOptions.map(({ label, icon }) => (
      <Box
        key={label}
        onClick={() => handleTabChange(label)}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          cursor: 'pointer',
          pb: 1,
          borderBottom: activeTab === label ? '3px solid #FF5733' : '3px solid transparent',
          color: activeTab === label ? '#FF5733' : '#555',
          transition: 'border 0.2s, color 0.2s',
          '&:hover': {
            color: '#FF5733',
          },
        }}
      >
        {icon}
        <Typography
          variant="caption"
          sx={{
            mt: 0.5,
            fontWeight: activeTab === label ? 'bold' : 'normal',
          }}
        >
          {label}
        </Typography>
      </Box>
    ))}
  </Box>
)}

    { /*[ //'Self Assessment', 
     'Target Companies', 'Email Outreach', 'Linkedin Outreach'].map((tab, index) => (
        <Button
    key={index}
    onClick={() => handleTabChange(tab)}
    startIcon={tab === 'Linkedin Outreach' ? <LinkedInIcon /> : <MailIcon />}
    sx={{
      fontSize: '0.875rem',
      fontWeight: activeTab === tab ? 'bold' : 'normal',
      color: activeTab === tab ? '#FF5733' : 'text.primary',
    }}
  >
    {tab}
  </Button>
    ))}
    {(user.role === "admin" || user.role === "recruiter") && (
        <a
            style={{
                textDecoration: 'none',
                color: activeTab === 'Add New' ? '#FF5733' : '#333', // Highlight color for active tab
                fontWeight: activeTab === 'Add New' ? 'bold' : 'normal',
                padding: '0.5rem 1rem',
                borderRadius: '20px',
                transition: 'all 0.3s ease',
                cursor: 'pointer',
                ':hover': {
                    color: '#FF5733', // Hover color
                    backgroundColor: '#f0f0f0', // Light background on hover
                }
            }}
            onClick={() => handleTabChange("Client Details")}     
        >
            Client Details
        </a>
    )*/}
</div>
                {
                activeTab === 'Client Details' && ( <ClientDetails client={Project} />)
                }
                    
                {
                activeTab === 'Self Assessment' && (<SelfAssessment email={email} SelfAssessment={Project.SelfAssessment} />)
                }
                {                    
                (activeTab === 'Target Companies') && (
                    <Paper elevation={1} sx={{ mt: 4 }}>                    

                    {(user.role !=="admin" && user.role !=="recruiter") && Object.keys(userStatus).map((status) => (
                        (targetCompanies.filter(company =>  userStatus[status].includes(company.Status)).length>0) && (
                        <Button
                            key={status}
                            variant="contained"
                            color={CompanyStatus === status ? "info" : "inherit"}
                            size="small"
                            onClick={() => {
                                setCompanyStatus(userStatus[status]);
                            }}
                        >
                            {status} {targetCompanies.filter(company => userStatus[status].includes(company.Status)).length}
                        </Button>
                    )))}
                    
                    {(user.role ==="admin" || user.role ==="recruiter") &&Object.keys(adminStatus).map((state) => (
                        (targetCompanies.filter(company =>  adminStatus[state].includes(company.Status)).length>0) && (
                        <Button
                            key={state}                                                
                            variant="contained"
                            color={CompanyStatus === state ? "info" : "inherit"} 
                            size="small"
                            onClick={() => {    
                                setCompanyStatus(state)}}
                                > 
                                {state} {targetCompanies.filter(company => company.Status === state).length} </Button>
                                                  )
                                                                              ))                        
                        }                             
                                                        

                                                        
                                                    { 
                                                    activeTab === 'Target Companies' && (
                                                    <Card elevation={3}  variant="contained" sx={{ p: 2 }} style={{ display: 'flex' }}>                                                        
                                                        <FormControl fullWidth sx={{ mt: 2 }}>                            
                                                            <Autocomplete
                                                                options={options}
                                                                getOptionLabel={(option) => option.name || option}
                                                                renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="Add a Company"
                                                                    placeholder="Start typing to search..."
                                                                    InputProps={{...params.InputProps,endAdornment: (
                                                                                                <>
                                                                                                {Cloading ? 'Loading...' : null}
                                                                                                {params.InputProps.endAdornment}
                                                                                                </>
                                                                                            )}}                                       />    
                                                                                                )}
                                                                    onInputChange={(event, newValue) => {setInputValue(newValue);setNewCompany({organization: newValue });}}
                                                                    onChange={(event, newValue) => {setNewCompany({organization: newValue.name });}}
                                                                    freeSolo
                                                                    loading={Cloading}
                                                                />
                                            </FormControl>
                        <Button 
                            variant="contained" 
                            color="primary" 
                            onClick={handleAddCompany}
                            sx={{ mt: 2 }}
                        >
                            Add Company
                        </Button>
                    </Card>
                    )}
                <CardContent>
                    {loading ? (
                        <Typography variant="h6" sx={{ textAlign: 'center', py: 4 }}>Loading...</Typography>
                    ) : (targetCompanies && targetCompanies.length > 0 ? (
                        <div style={{ display: 'grid', gap: '20px' }}>
                            {
                            targetCompanies.map(company => company && (CompanyStatus.includes(company.Status)) && (                                
                                <Card key={company._id} variant="contained" sx={{ p: 2 }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginBottom: '16px' }}>
                                        <CompanyLogo companyName={company?.Name} sx={{ width: '60px', height: '60px' }} />
                                        <div>
                                        <Typography variant="h6" component="h2">
                                            <Link href={company?.Website} target="_blank" rel="noreferrer">
                                            {company?.Name}
                                            </Link>
                                           
                                        {(user.role === "admin" || user.role === "recruiter") && (
                                        <Button 
                                            onClick={() => setOrgEdit(company?.Organization)}                                       
                                            startIcon={<EditIcon />}
                                        >                                            
                                        </Button>)}</Typography>
                                            <Typography color="text.secondary">{company?.Industry || ''}</Typography>                                          
                                            
                                            <Typography>{
                                            (user.role === "admin" || user.role === "recruiter")? 
                                                    company?.Status
                                                    :Object.keys(userStatus).find(key => userStatus[key].includes(company?.Status))                                                        
                                            } - {company?.Priority}</Typography>                                            
                                            <Typography 
                                                component="a" 
                                                href={company?.Website} 
                                                target="_blank" 
                                                sx={{ textDecoration: 'none', color: 'primary.main' }}
                                            >                                                
                                            </Typography>
                                            <Typography sx={{ fontWeight: 'bold' }}>{company?.Remarks}</Typography>                                            
                                        </div>
                                        <Button
                                            onClick={() =>{setSelectedCompany(company?.Organization);setActiveTab('Email Outreach');}}
                                            variant="contained"
                                            sx={{ marginLeft: 'auto' }}
                                            startIcon={<GroupIcon />}
                                            >{decisionMakers?.filter(dm => dm.TargetCompanyId == company?.Organization).length}</Button>
                                    </div>
                                    <Typography sx={{ mb: 2 }}>{company?.Description}</Typography>
                                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                                        {company?.status}
                                    </Typography>




                                    <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                                        {(user.role === "admin" || user.role === "recruiter") && (
                                            Recruiteroption[company.Status] && Recruiteroption[company.Status].map((status) => (
                                                <Button
                                                    key={status}
                                                    variant='contained'
                                                    size="small"
                                                    color={company.Status === status ? "info" : "inherit"}
                                                    onClick={() => handleStatusChange(company.Name, status)}
                                                    sx={{
                                                        borderRadius: '20px',
                                                        textTransform: 'none',
                                                        minWidth: '120px'
                                                    }}
                                                >
                                                    {status}
                                                </Button>
                                            ))
                                        )}
                                            
                                        {(company.Status === 'To be Reviewed' || company.Status === 'Reject' || company.Status ===`Hold for Later`) && (
                                            <>
                                            <Button                                            
                                            variant='contained'
                                            size="small"
                                            color="primary"
                                            onClick={() => {
                                                document.getElementById(`div-${company._id}`).style.display = 'block';
                                                document.getElementById(`button-${company._id}`).style.display = 'none';
                                                document.getElementById(`buttonD-${company._id}`).style.display = 'none';
                                            }} 
                                            id={`button-${company._id}`}
                                            > 
                                            Approve 
                                            </Button>
                                            <div id={`div-${company._id}`} style={{ display: 'none' }}>
                                            <Button 
                                                variant='contained'
                                                size="small"
                                                onClick={() => handleStatusChange(company.Name, 'Approved for Research','High')} //Reject	Hold for Later
                                                sx={{
                                                    borderRadius: '20px',
                                                    textTransform: 'none',
                                                    minWidth: '120px'
                                                }}
                                            >
                                            High Priority 
                                            </Button><Button 
                                                variant='contained'
                                                size="small"
                                                onClick={() => handleStatusChange(company.Name, 'Approved for Research',"Medium")} //Priority 1 Approved	Priority 2 Approved	Priority 3 Approved	Reject	Hold for Later
                                                sx={{
                                                    borderRadius: '20px',
                                                    textTransform: 'none',
                                                    minWidth: '120px'
                                                }}
                                            >
                                            Medium Priority
                                            </Button><Button 
                                                variant='contained'
                                                size="small"
                                                onClick={() => handleStatusChange(company.Name, 'Approved for Research','Low')} //Priority 1 Approved	Priority 2 Approved	Priority 3 Approved	Reject	Hold for Later
                                                sx={{
                                                    borderRadius: '20px',
                                                    textTransform: 'none',
                                                    minWidth: '120px'
                                                }}
                                            >
                                            Low Priority
                                            </Button>
                                            </div>
                                            </>)
                                        }
                                        {
                                            (company.Status === `To be Reviewed`) &&
                                            (
                                                <>
                                                
                                            <Button 
                                                variant='contained'
                                                size="small"
                                                color="error"
                                                onClick={() => StatusChangeWithComment(company, 'Reject')} //Priority 1 Approved	Priority 2 Approved	Priority 3 Approved	Reject	Hold for Later
                                                sx={{
                                                    borderRadius: '20px',
                                                    textTransform: 'none',
                                                    minWidth: '120px'
                                                }}
                                                id={`buttonD-${company._id}`}
                                            >
                                                Reject
                                            </Button>
                                            {/* // }
                                                <Button                                            
                                            variant='contained'
                                            size="small"
                                            onClick={() => {
                                                document.getElementById(`divD-${company._id}`).style.display = 'block';
                                                document.getElementById(`button-${company._id}`).style.display = 'none';
                                                document.getElementById(`buttonD-${company._id}`).style.display = 'none';
                                            }} 
                                            id={`buttonD-${company._id}`}
                                            > 
                                            Reject 
                                            </Button>
                                            <div id={`divD-${company._id}`} style={{ display: 'none' }}>
                                            <Button 
                                                variant='contained'
                                                size="small"
                                                onClick={() => StatusChangeWithComment(company, 'Reject')} //Priority 1 Approved	Priority 2 Approved	Priority 3 Approved	Reject	Hold for Later
                                                sx={{
                                                    borderRadius: '20px',
                                                    textTransform: 'none',
                                                    minWidth: '120px'
                                                }}
                                            >
                                                Reject
                                            </Button>
                                            <Button 
                                                variant='contained'
                                                size="small"
                                                onClick={() => StatusChangeWithComment(company, 'Hold for Later')} //Priority 1 Approved	Priority 2 Approved	Priority 3 Approved	Reject	Hold for Later
                                                sx={{
                                                    borderRadius: '20px',
                                                    textTransform: 'none',
                                                    minWidth: '120px'
                                                }}
                                            >
                                                Hold for Later
                                            </Button>     
                                            </div>    
                                            {
                                            //*/
                                            }                                        
                                            </>
                                            )
                                        }
                                        {
                                        (company.Status === `Hold for Later` ) &&
                                            (
                                                <>
                                                
                                            <Button 
                                                variant='contained'
                                                size="small"
                                                onClick={() => StatusChangeWithComment(company, 'Reject')} //Priority 1 Approved	Priority 2 Approved	Priority 3 Approved	Reject	Hold for Later
                                                sx={{
                                                    borderRadius: '20px',
                                                    textTransform: 'none',
                                                    minWidth: '120px'
                                                }}
                                            >
                                                Reject
                                            </Button>
                                            </>
                                        )}
                                        {company.Status === 'Research Completed' && (
                                            <Button 
                                                variant='contained'
                                                size="small"
                                                onClick={() => handleStatusChange(company.Name, 'Reachout Initiated')}
                                                sx={{
                                                    borderRadius: '20px',
                                                    textTransform: 'none',
                                                    minWidth: '120px'
                                                }}
                                            >
                                                Reachout Initiated
                                            </Button>
                                        )}
                                        
                                        {(user.role === "admin" || user.role === "recruiter") && (
                                            <FormControl sx={{ minWidth: 120 }}>
                                                <TextField
                                                    select
                                                    label="Change Status"
                                                    value={company.Status}
                                                    onChange={(e) => handleStatusChange(company.Name, e.target.value)}
                                                    SelectProps={{
                                                        native: true,
                                                    }}
                                                >
                                                    {['To be Reviewed', 'Approved for Research', 'Reject', 'Research Completed', 'Reachout Initiated','DMs Identified','Discarded After Research','DMs Verified','Modifications Required','Pending Approval','Share with Client'].map((status) => (
                                                        <option key={status} value={status}>
                                                            {status}
                                                        </option>
                                                    ))}
                                                </TextField>
                                            </FormControl>
                                        )}
                                        <span style={{ display: 'flex', gap: '8px', marginLeft: 'auto' }}>
                                        {(user.role === "admin" || user.role === "recruiter") && (
                                        <Button
                                            variant="outlined"
                                            size="small"
                                            onClick={() => EditReMark(company)}
                                            sx={{
                                                borderRadius: '20px',
                                                textTransform: 'none',
                                                minWidth: '120px'
                                            }}
                                            startIcon={<EditIcon />}
                                        >
                                            Remark
                                        </Button>
                                        )}
                                        <Button
                                            variant="outlined"
                                            size="small"
                                            onClick={() => setShowComments(company._id)}
                                            sx={{
                                                borderRadius: '20px',
                                                textTransform: 'none',
                                                minWidth: '120px',
                                                marginLeft: 'auto'
                                            }}
                                            startIcon={<EditIcon />}
                                        >
                                           {company.comments?.length || '' }  Comments
                                        </Button>
                                        </span>
                                    </div>

                                    <div style={{ marginTop: '16px' }}>                                        
                                        {showComments === company._id && (
                                            <div style={{ marginTop: '16px' }}>
                                                {company.comments.map((comment, index) => (
                                                    <Card key={index} variant="contained" sx={{ p: 2, mb: 2 }}>
                                                        <Typography variant="body2" color="text.secondary">
                                                            <b>{comment.userName}</b> * {new Date(comment.timestamp).toLocaleString()}
                                                        </Typography>
                                                        <Typography variant="body1">{comment.comment}</Typography>
                                                    </Card>
                                                ))}
                                                <div style={{ display: 'flex', gap: '8px', flexDirection: 'row' }}>
                                                <TextField
                                                    fullWidth
                                                    label="Add a comment"
                                                    multiline
                                                    rows={2}
                                                    value={newComment?.comment || ''}
                                                    onChange={(e) => 
                                                    setNewComment({
                                                        comment: e.target.value,
                                                        user: user._id,
                                                        userName: user.name,
                                                        timestamp: new Date()
                                                    })}
                                                    sx={{ mt: 2 }}
                                                />
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={() => handleAddComment(company._id)}
                                                    sx={{ mt: 2 }}
                                                >
                                                    Add Comment
                                                </Button>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </Card>
                            ))}
                        </div>
                    ) : (
                        <Typography variant="h6" sx={{ textAlign: 'center', py: 4 }}>No companies found</Typography>
                    ))}

                    <div style={{
                        position: 'fixed',
                        right: 0,
                        top: 0,
                        width: '400px',
                        height: '100%',
                        //backgroundColor: '#fff',
                        boxShadow: '-3px 0 20px rgba(0,0,0,0.1)',
                        padding: '30px',
                        overflowY: 'auto',
                        display: OrgEdit ? 'block' : 'none'
                    }}>
                        <OrgForm orgId={OrgEdit} setOrgEdit={setOrgEdit} />
                    </div>
                </CardContent>
                </Paper>
                )}
                {activeTab === 'Email Outreach' && (                    
                    <Reachouts decisionMakers={(user.role === "admin" || user.role==="recruiter") ? decisionMakers : decisionMakers.filter(dm => dm.WorkEmail !=="")} Project={Project} fetchDecisionMakers={fetchDecisionMakers} selectedCompany={selectedCompany} setSelectedCompany ={setSelectedCompany} /> 
                )}
                {activeTab === 'Linkedin Outreach' && (
                    <LinkedInReachOuts decisionMakers={decisionMakers.filter(dm => dm.WorkEmail === "")} Project={Project} fetchDecisionMakers={fetchDecisionMakers}/> 
                )}

            </>    
        )}
                
    { (!Project.email) && ( <Signup />)}   
        <Dialog open={openSetupGmail} maxWidth="md" fullWidth onClose={() => setOpenSetupGmail(false)}>
            <DialogContent>
                <SetupGmail />
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setOpenSetupGmail(false)}>Close</Button>
            </DialogActions>
        </Dialog>
                <Dialog open={openModal} onClose={handleCloseModal}>
                    <DialogTitle>Rejection Reason is mandatory</DialogTitle>
                    <DialogContent>
                        <TextField
                            label="Rejection Reason..."
                            value={reason}
                            onChange={(e) => {
                                setReason(e.target.value);
                                setNewComment({
                                    comment: newStatus + " : " + e.target.value,
                                    user: user._id,
                                    userName: user.name,
                                    timestamp: new Date()
                                });
                            }}                          
                            fullWidth
                            multiline
                            rows={4}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseModal}>Cancel</Button>
                        <Button onClick={handleSubmit} color="primary">Submit</Button>
                    </DialogActions>
                </Dialog>
        </Container>
        
        </>
    );
    
};

export default Execedge;